interface ITextObject {
  h1: string;
  title: string;
  description: string;
  callToAction: string;
}

interface IFunctionsObject {
  getFullDescription: (count: string | number) => string;
}

const meta: ITextObject = {
  h1: 'Продажа, аренда и покупка по заявкам транспорта и спецтехники',
  title:
    'Тракмаркет — продажа, аренда и покупка по заявкам транспорта и спецтехники по всей России',
  description: 'Продажа, аренда и покупка по заявкам транспорта и спецтехники на Truckmarket',
  callToAction: 'Сравните цены и выберите лучшее предложение на ATI.SU',
};

const functions: IFunctionsObject = {
  getFullDescription: (count: string | number) =>
    `${meta.description}. Более ${count} объявлений о продаже и аренде транспорта и спецтехники. ${meta.callToAction}`,
};

export default {
  meta,
  functions,
};
